import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import PrivacyPolicy from './pages/PrivacyPolicy';
import HowToPlay from './pages/HowToPlay';
import About from './pages/About';
import FAQ from './pages/FAQ';
import Tips from './pages/Tips';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
const pathname = window.location.pathname;
const isPrivacyPage = pathname === '/privacy';
const isHowToPlayPage = pathname === '/how-to-play';
const isAboutPage = pathname === '/about';
const isFaqPage = pathname === '/faq';
const isTipsPage = pathname === '/tips';

function Page() {
  if (isPrivacyPage) return <PrivacyPolicy />;
  if (isHowToPlayPage) return <HowToPlay />;
  if (isAboutPage) return <About />;
  if (isFaqPage) return <FAQ />;
  if (isTipsPage) return <Tips />;
  return <App />;
}

root.render(
  <React.StrictMode>
    <Page />
  </React.StrictMode>
);

document.body.classList.add('app-loaded');

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
